export const MAP_CONFIG_BY_COUNTRY: Record<
  string,
  {
    center: { lat: number; lng: number };
    zoom: number;
  }
> = {
  sv: { center: { lat: 13.794185, lng: -88.899994 }, zoom: 8 },
  gt: { center: { lat: 15.5, lng: -90.25 }, zoom: 7 },
  pa: { center: { lat: 8.4, lng: -80.1 }, zoom: 7 },
};

// Stroke oscuro visible sobre el fondo verde, peso 4 para que las divisiones sean claras
export const POLYGON_STYLE = {
  strokeColor: "#001a0d",
  strokeOpacity: 1.0,
  strokeWeight: 4,
  fillColor: "#05EE84",
  fillOpacity: 1,
};

export const MAP_OPTIONS = {
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: false,
  gestureHandling: "greedy",
  fullscreenControl: false,
  clickableIcons: false,
  styles: [
    // Tierra
    { featureType: "landscape", elementType: "geometry.fill", stylers: [{ color: "#00321A" }] },
    // Mar
    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#002412" }] },
    // Oculta todo lo demás: carreteras, POIs, tránsito, labels, administrativo
    { featureType: "road", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
  ],
};
